import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'

import Button from 'components/Button'
import DriversForm from 'components/DriversForm'

import {
  prevStep,
  resetState,
} from 'scenes/ClientDetail/components/AddVehicleModal/actions'


import './style.scss'


export class DriversDataStep extends BasePureComponent {
  constructor(props) {
    super(props)
    this._bind('_submitForm', '_onSuccess', '_renderFooter')
  }

  _submitForm(submitForm) {
    return (evt) => {
      evt.preventDefault()
      this.setState({
        buttonProps: {
          disabled: true
        }
      })
      submitForm()
    }
  }

  _onSuccess() {
    this.context.hideModal()
    this.props.resetState()
  }

  _renderFooter(submitForm) {
    return (
      <div className="DriversDataStep__footer">
        <Button buttonType="primary-inverse" onClick={this.props.prevStep}>Regresar</Button>
        <Button onClick={this._submitForm(submitForm)}>Finalizar</Button>
      </div>
    )
  }

  render() {
    return (
      <section className="DriversDataStep">
        <div className="DriversDataStep__rows">
          <DriversForm
            clientId={this.props.clientId}
            onSuccess={this._onSuccess}
            renderFooter={this._renderFooter}
            vehicleId={this.props.vehicleId}
          />
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentStep: state.addVehicleModal.get('currentStep'),
    vehicleId: state.addVehicleModal.get('vehicleId')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    resetState: () => dispatch(resetState()),
    prevStep: () => dispatch(prevStep()),
  }
}

DriversDataStep.contextTypes = {
  hideModal: PropTypes.func.isRequired
}


export default connect(mapStateToProps, mapDispatchToProps)(DriversDataStep)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/DriversDataStep/index.js